import { Injectable, signal,Signal, WritableSignal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {ProjectFilterModel} from '../../models/store/filter.model'; 
import { Project } from '../../models/store/project'; 
import {DropdownsDataResponse} from '../../models/store/filter.model';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root', 
})
export class SharedDataService {
  
  private dataSource = signal<any[]>([]); 
  private project: WritableSignal<string> = signal('');
  private navBarFilters: WritableSignal<ProjectFilterModel> = signal({commodityId: 0, regionId: 0, satId: 0, projectId: 0});
  private currentProjectsList: Project[] = [];

  private isNavbarEnabled = signal<boolean>(false);
  private dropdownsData: DropdownsDataResponse | null = null;
  private dropdownsLoading = signal<boolean>(true);

  
  private tabIndexSubject = new BehaviorSubject<number>(0);
  tabIndex$ = this.tabIndexSubject.asObservable();


  constructor(private apiService: ApiService) { }

  
  setActiveTab(index: number) {
    this.tabIndexSubject.next(index);
  }


  get dropdowsnsData(): DropdownsDataResponse | null {
    return this.dropdownsData;
  }

  set dropdowsnsData(data: DropdownsDataResponse) {
  this.dropdownsData = data
  this.dropdownsLoading.set(false);
  }

  get currentData() {
    return this.dataSource();
  }

  updateData(newData: any[]) {
    this.dataSource.set([...newData]); 
  }

  setProject(project: string) {
    this.project.set(project);
}

  getProject():string{
    return this.project();
  }

  getNavBarFilters(){
    return this.navBarFilters();
  }

  setNavBarFilters(filters: ProjectFilterModel){
    this.navBarFilters.set(filters);
  }

  setCurrentProjectsList(projects: Project[]){
    this.currentProjectsList = projects;
  }

  getCurrentProjectsList(): Project[]{
    return this.currentProjectsList;
  }

  setIsNavbarEnabled(flag: boolean) {
    this.isNavbarEnabled.set(flag);
  }

  getIsNavbarEnabled(): boolean {
    return this.isNavbarEnabled();
  }

  getDropdownsData(): Observable<DropdownsDataResponse> {
    return this.apiService.get('api/Data/GetDropdownsData/dropdownsData');
  }

  // Global loading state for dropdowns (sats/regions/commodities/projects)
  setDropdownsLoading(flag: boolean) {
    this.dropdownsLoading.set(flag);
  }

  getDropdownsLoading(): boolean {
    return this.dropdownsLoading();
  }
}
